<!-- File: src/components/CookiesModal.vue -->
<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="cookies-modal">
      <div class="title">
        {{ $t("About Cookies") }}
      </div>
      <div class="desc">
        {{
          $te("This Website stores cookies on your computer")
            ? $t("This Website stores cookies on your computer")
            : `This Website stores cookies on your computer. These cookies collect information about how you
                navigate our Website and allow us to remember you. We use this information to improve and customise your
                browsing experience and for analytics and metrics about our visitors on this Website.`
        }}
        <br />
        {{
          $te("Before you proceed with using our Website")
            ? $t("Before you proceed with using our Website")
            : `Before you proceed with using our Website, please get acquainted with the way we handle a User's data
                in our Privacy Policy and the use of Cookies in the Cookies Policy.`
        }}
        <br />
        {{
          $te("You can either accept or decline use of Cookies")
            ? $t("You can either accept or decline use of Cookies")
            : `You can either accept or decline use of Cookies. If you opt to decline Cookies your information won't
                be tracked when you visit this Website.`
        }}
        <router-link
          v-if="cookiePage"
          :to="`/pages/${cookiePage.id}`"
          class="desc blue"
        >
          {{ $t("Cookie Policy") }}
        </router-link>
      </div>
      <div class="buttons">
        <button class="button gray" @click="acceptCookies">
          {{ $t("Accept") }}
        </button>
        <button class="button" @click="declineCookies">
          {{ $t("Decline") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { COOKIE_PAGE } from "@/store/modules/staticPages";
import { mapGetters } from "vuex";

export default {
  name: "CookiesModal",
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    ...mapGetters("staticPages", ["getCookiePage"]),
    cookiePage() {
      return this.getCookiePage;
    },
  },
  created() {
    this.COOKIE_PAGE = COOKIE_PAGE;
  },
  methods: {
    showModal() {
      const cookiesAccepted = localStorage.getItem("cookiesAccepted");
      if (!cookiesAccepted || cookiesAccepted !== "true") {
        this.isVisible = true;
      }
    },
    acceptCookies() {
      localStorage.setItem("cookiesAccepted", "true");
      this.isVisible = false;
    },
    declineCookies() {
      localStorage.setItem("cookiesAccepted", "false");
      this.isVisible = false;
    },
  },
  mounted() {
    this.showModal();
  },
};
</script>

<style lang="scss" scoped>
.cookies-modal {
  background-color: #333344;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 500px;
  margin: 40px auto 0;
  border-radius: 8px;
}

.title {
  margin-bottom: 16px;
}

.buttons {
  display: flex;
  justify-content: center;
}

.cookies-modal .button {
  margin: 16px 8px;
  width: 120px;
  display: inline-block;
}

.button.gray {
  background-color: #666;
  color: white;
}
</style>
